import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const openfolder: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M18.51 9.5 18.51 7.5 10.51 7.5 10.51 5.5 4.5 5.5 4.51 17.5 18.659 17.5 21.31 9.5 7.36 9.5 4.51 17.5"
      />
    </svg>
  );
};
